import { configureStore } from '@reduxjs/toolkit';
import paymentReducer from '@/store/paymentSlice';
import uiReducer from '@/store/uiSlice';
export const store = configureStore({
    reducer: {
        payment: paymentReducer,
        ui: uiReducer,
    },
});
